import { render, staticRenderFns } from "./GoBonusAnimation.vue?vue&type=template&id=1339894d&scoped=true&"
import script from "./GoBonusAnimation.vue?vue&type=script&lang=js&"
export * from "./GoBonusAnimation.vue?vue&type=script&lang=js&"
import style0 from "./GoBonusAnimation.vue?vue&type=style&index=0&id=1339894d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1339894d",
  null
  
)

export default component.exports